import { useState } from "react";
import { faqs } from "@/mocks/data";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="relative w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.4fr]">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">F.A.Q</p>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">常见问答</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于反差雷达是什么、怎么更新、内容如何把关等问题，这里集中为你解答。若仍有疑问，欢迎到页尾联系表单留言。
            </p>
            <a
              href="#about"
              className="mt-5 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              还有问题？联系我们
              <i className="ri-arrow-right-line ml-1.5" />
            </a>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    open ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-100"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="font-heading text-base font-bold text-foreground-950">{f.q}</h3>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}